export const colors = {
  background: '#FFFFF2',
  darkBackground: '#ECECEC',
  title: '#3F2A24',
  description: '#454545',
};